/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function toggleDiscountsOnDateTimePassed(date, time, timezoneOffset = 0) {
  const discountElements = document.querySelectorAll('.discount-active');
  const now = new Date();
  const dateParts = date.split('-');
  const timeParts = time.split(':');
  const targetTime = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]));
  targetTime.setUTCMinutes(targetTime.getUTCMinutes() + timezoneOffset);
  console.log (now);
  if (now >= targetTime) {
    discountElements.forEach(element => {
      element.classList.toggle('hidden');
    });
  }
}


function toggle() {
    var ele = document.getElementById("toggleText");
    var text = document.getElementById("displayText");
    if(ele.style.display == "block") {
            ele.style.display = "none";
        text.innerHTML = "mehr...";
    }
    else {
        ele.style.display = "block";
        text.innerHTML = "weniger...";
    }
} 



document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('a.anchor'); // Get all anchor links with class "anchor"
    const headings = document.querySelectorAll('h2'); // Get all h2 elements

    // Assign unique IDs to each h2 element based on its position
    headings.forEach((heading, index) => {
        const sectionId = `section-${index}`; // Generate a unique id with the correct pattern (section-0, section-1, etc.)
        heading.id = sectionId; // Assign the id to the h2 element
        console.log(`Assigned ID ${sectionId} to heading: ${heading.innerText}`); // Debugging line
    });

    // Now loop through each anchor link
    links.forEach((link) => {
        const linkText = link.innerText.trim(); // Get the text inside the link
        console.log(`Looking for heading matching link: "${linkText}"`);

        // Use Array.from to make sure we can use find() on the NodeList
        const matchingHeading = Array.from(headings).find(heading => {
            return heading.innerText.trim() === linkText; // Compare trimmed text content
        });

        if (matchingHeading) {
            console.log(`Found matching heading: ${matchingHeading.innerText} with ID ${matchingHeading.id}`);
            // Use the ID of the matched h2 element for the link href
            link.setAttribute('href', `#${matchingHeading.id}`);
        } else {
            console.log(`No match found for link: ${linkText}`);
        }
    });
});
// Function to get the value of a specific cookie by name
function getCookieValue(cookieName) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

// Function to store discount code in sessionStorage from the cookie
function storeDiscountCodeFromCookie() {
    const discountCookieName = "discount_code"; // Shopify's discount cookie name
    const discountCode = getCookieValue(discountCookieName); // Get the discount code from the cookie

    if (discountCode) {
        sessionStorage.setItem('discount_code', discountCode); // Store it in sessionStorage
    }
}

// Function to parse discount code to extract discount percentage
function parseDiscountCode(discountCode) {
  const match = discountCode.match(/(.+)_([\d]+)$/); // Regex to extract name and percentage
  
  if (match) {
    return {
      name: match[1],
      percentage: parseInt(match[2], 10),
    };
  }

  // Special case: VOLUME-UP always gets 10%
  if (discountCode.toUpperCase() === "VOLUME-UP") {
    return {
      name: discountCode,
      percentage: 10,
    };
  }

  // Default fallback
  return {
    name: discountCode,
    percentage: 0,
  };
}


// Function to apply discount to the product page (if applicable)
function applyDiscountToProductPage() {
    const discountKey = "discount_code";
    const discountCode = sessionStorage.getItem(discountKey);

    if (discountCode) {
        const discountBadge = document.getElementById("discount-badge");
        if (discountBadge) {
            discountBadge.style.display = "flex";

            const { name, percentage } = parseDiscountCode(discountCode);

            const discountCodeSpan = document.getElementById("discount-code");
            const discountedPriceSpan = document.getElementById("discounted-price");

            if (discountCodeSpan && discountedPriceSpan) {
                const originalPriceElement = document.querySelector(".original-price");
                if (originalPriceElement) {
                    const priceText = originalPriceElement.textContent.trim();
                    const originalPrice = parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));

                    if (!isNaN(originalPrice)) {
                        const discountAmount = originalPrice * (percentage / 100); // Correct discount calculation
                        const discountedPrice = originalPrice - discountAmount;

                        // Update the text to match the desired format
                        discountCodeSpan.textContent = `${name} (-€${discountAmount.toFixed(2)})`;
                        discountedPriceSpan.textContent = `€${discountedPrice.toFixed(2)}`;
                    } else {
                        console.error("Could not parse original price:", priceText);
                    }
                }
            }
        }
    }
}

// Function to apply discount to product cards (if applicable)
function applyDiscountToProductCards() {
    const discountKey = "discount_code";
    const discountCode = sessionStorage.getItem(discountKey);

 if (discountCode) {
 

        const { name, percentage } = parseDiscountCode(discountCode);

        const productCards = document.querySelectorAll(".product-card");
        productCards.forEach((card) => {
            const originalPriceElement = card.querySelector(".original-price");
            const discountBadgeElement = card.querySelector(".discount-badge");
            const discountCodeElement = discountBadgeElement?.querySelector(".discount-code");

            if (originalPriceElement && discountBadgeElement && discountCodeElement) {
                const priceText = originalPriceElement.textContent.trim();
                const originalPrice = parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));

                if (!isNaN(originalPrice)) {
                    const discountAmount = originalPrice * (percentage / 100);
                    const discountedPrice = originalPrice - discountAmount;

                    // Update the text to match the desired format
                    discountCodeElement.textContent = `${name} (-€${discountAmount.toFixed(2)})`;
                    discountBadgeElement.querySelector(".discounted-price").textContent = `€${discountedPrice.toFixed(2)}`;
                    discountBadgeElement.style.display = "flex";
                } else {
                    console.error("Could not parse original price:", priceText);
                }
            }
        });
    }
}


// Event Listener for DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    // Store discount code from the cookie in sessionStorage
    storeDiscountCodeFromCookie();

    // Check if it's a product page or collection page
    if (window.location.pathname.includes("/products/")) {
        applyDiscountToProductPage(); // Apply discount on product page
    }

    // Apply discount to product cards (if any are present on the page)
    applyDiscountToProductCards();
});
